import { render } from "./DiceOne.vue?vue&type=template&id=7ff56b21"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/DiceOne.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ff56b21"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ff56b21', __exports__)) {
    api.reload('7ff56b21', __exports__)
  }
  
  module.hot.accept("./DiceOne.vue?vue&type=template&id=7ff56b21", () => {
    api.rerender('7ff56b21', render)
  })

}


export default __exports__